import type { NodeV2 } from '@vedalib/editor'
import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getNodeStyle } from 'services/Store/Project/selectors'
import type { Block, IBlockMode } from 'services/Store/Project/types'

import DragPlaceholderAbsolute from './DragPlaceholderAbsolute'
import DragPlaceholderFlex from './DragPlaceholderFlex'
import DragPlaceholderGrid from './DragPlaceholderGrid'

const MAP = {
  grid: DragPlaceholderGrid,
  flex: DragPlaceholderFlex,
  absolute: DragPlaceholderAbsolute,
}

interface IPlaceholderProps {
  block: Block
  node: NodeV2
  mode: IBlockMode
  nodeRef: React.RefObject<HTMLDivElement>
}

const DragPlaceholder: React.FC<IPlaceholderProps> = ({ block, mode, node, nodeRef }) => {
  const styles = useProjectContext(getNodeStyle, block.uuid, node.id)
  const Component = node.repeatable
    ? DragPlaceholderFlex
    : (styles?.display && MAP[styles?.display]) || NOOP

  return <Component block={block} mode={mode} node={node} nodeRef={nodeRef} />
}

export default React.memo(DragPlaceholder)
